<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="content-main">
        <v-tabs v-model="tab">
          <v-tab v-for="item in items" :key="item.key">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="0">
            <ResultadosPorDia :emitter.sync="emitter" :emitters="emitters" :emitters_loaded="emitters_loaded"></ResultadosPorDia>
          </v-tab-item>
          <v-tab-item key="1">
            <ResultadosPorSemana :emitter.sync="emitter" :emitters="emitters" :emitters_loaded="emitters_loaded"></ResultadosPorSemana>
          </v-tab-item>
          <v-tab-item key="2">
            <ResultadosPorMes :emitter.sync="emitter" :emitters="emitters" :emitters_loaded="emitters_loaded"></ResultadosPorMes>
          </v-tab-item>
          <v-tab-item key="3">
            <ResultadosPorCentroCosto :emitter.sync="emitter" :emitters="emitters" :emitters_loaded="emitters_loaded"></ResultadosPorCentroCosto>
          </v-tab-item>
        </v-tabs-items>
        <p v-if="emitters_loaded && !emitters.length" class="caption mt-4">No hay empresas habilitadas. Cargá un emisor para ver el reporte.</p>
      </div>
    </v-container>
  </div>
</template>

<script>
import ResultadosPorDia from "./ResultadosPorDia.vue";
import ResultadosPorSemana from "./ResultadosPorSemana.vue";
import ResultadosPorMes from "./ResultadosPorMes.vue";
import ResultadosPorCentroCosto from "./ResultadosPorCentroCosto.vue";
import Title from "@/components/Title.vue";
import { emmiterService } from "@/libs/ws/emmiterService";

export default {
  components: { Title, ResultadosPorDia, ResultadosPorSemana, ResultadosPorMes, ResultadosPorCentroCosto },
  data() {
    return {
      page_title: "Resultados por Tesorería",
      tab: 0,
      emitter: null,
      emitters: [],
      emitters_loaded: false,
      items: [
        { tab: "Por Día", key: 0 },
        { tab: "Por Semana", key: 1 },
        { tab: "Por Mes", key: 2 },
        { tab: "Por Centro de Costo", key: 3 },
      ],
    };
  },
  watch: {
    // La empresa es obligatoria: si se borra el texto, se restaura la anterior.
    emitter(nuevo, viejo) {
      if ((!nuevo || !nuevo.id) && viejo) this.emitter = viejo;
    },
  },
  mounted() {
    emmiterService
      .filter({ enabled: true })
      .then((response) => {
        if (!response.status) {
          this.$toast.error(response.msg || "No se pudieron cargar las empresas.", "Error");
          return;
        }
        this.emitters = response.result || [];
        // Por defecto se elige la primera empresa.
        if (this.emitters.length > 0) this.emitter = this.emitters[0];
      })
      .catch((e) => this.$toast.error((e && e.msg) || "No se pudieron cargar las empresas.", "Error"))
      .finally(() => (this.emitters_loaded = true));
  },
};
</script>
